'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _entries = require('lodash/entries');

var _entries2 = _interopRequireDefault(_entries);

var _constants = require('playable/dist/src/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayerAPIFacade = (_temp = _class = function (_React$Component) {
  _inherits(PlayerAPIFacade, _React$Component);

  function PlayerAPIFacade(props) {
    _classCallCheck(this, PlayerAPIFacade);

    var _this = _possibleConstructorReturn(this, (PlayerAPIFacade.__proto__ || Object.getPrototypeOf(PlayerAPIFacade)).call(this, props));

    _this.unbindEvents = function () {
      var eventEmitter = _this.props.eventEmitter;


      (0, _forEach2.default)(_this.listeners, function (handler, event) {
        eventEmitter.off(event, handler);
        delete _this.listeners[event];
      });
    };

    _this.addListener = function (event, handler) {
      var eventEmitter = _this.props.eventEmitter;


      var wrappedHandler = function wrappedHandler() {
        if (_this._isMounted) {
          handler.apply(undefined, arguments);
        }
      };
      _this.listeners[event] = wrappedHandler;
      eventEmitter.on(event, wrappedHandler);
    };

    _this.setPlaybackStatusState = function (_ref) {
      var nextState = _ref.nextState;

      _this.setState({
        isVideoEnded: nextState === _constants.EngineState.ENDED,
        isVideoPaused: nextState === _constants.EngineState.PAUSED,
        isVideoPlaying: nextState === _constants.EngineState.PLAYING
      });

      _this.props.onPlaybackStateChanged(nextState);
    };

    _this.showMainBlockControls = function () {
      _this.setState({
        isControlsShown: true
      });
    };

    _this.hideMainBlockControls = function () {
      _this.setState({
        isControlsShown: false
      });
    };

    _this.setFullScreenState = function (isPlayerInFullScreen) {
      _this.setState({ isPlayerInFullScreen: isPlayerInFullScreen });
      _this.props.onFullScreenChanged(Boolean(isPlayerInFullScreen));
    };

    _this.hidePlayerUI = function () {
      var _this$props = _this.props,
          mainUIBlock = _this$props.mainUIBlock,
          cards = _this$props.cards;

      mainUIBlock.disableShowingContent();
      mainUIBlock.hide();
      cards.hide();
    };

    _this.showPlayerUI = function () {
      var _this$props2 = _this.props,
          mainUIBlock = _this$props2.mainUIBlock,
          cards = _this$props2.cards;

      mainUIBlock.enableShowingContent();
      mainUIBlock.show();
      cards.show();
    };

    _this.exitFullScreen = function () {
      var fullScreenManager = _this.props.fullScreenManager;


      if (fullScreenManager.isInFullScreen) {
        fullScreenManager.exitFullScreen();
      }
    };

    _this.pauseVideo = function () {
      var engine = _this.props.engine;

      engine.pause();
    };

    _this._isMounted = false;
    _this.listeners = {};

    _this.state = {
      isVideoEnded: false,
      isVideoPaused: true,
      isControlsShown: false,
      isPlayerInFullScreen: false
    };

    _this.bindEvents();
    return _this;
  }

  _createClass(PlayerAPIFacade, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEvents();
      this._isMounted = false;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _uiHandlers,
          _videoHandlers,
          _this2 = this;

      var _props = this.props,
          onError = _props.onError,
          onPlayAbort = _props.onPlayAbort,
          onSeek = _props.onSeek,
          onUserSeek = _props.onUserSeek,
          onMute = _props.onMute,
          onVolumeChange = _props.onVolumeChange;


      var uiHandlers = (_uiHandlers = {}, _defineProperty(_uiHandlers, _constants.UI_EVENTS.MAIN_BLOCK_SHOW, this.showMainBlockControls), _defineProperty(_uiHandlers, _constants.UI_EVENTS.MAIN_BLOCK_HIDE, this.hideMainBlockControls), _defineProperty(_uiHandlers, _constants.UI_EVENTS.FULL_SCREEN_STATE_CHANGED, this.setFullScreenState), _defineProperty(_uiHandlers, _constants.UI_EVENTS.PROGRESS_CHANGE, onUserSeek), _defineProperty(_uiHandlers, _constants.UI_EVENTS.GO_BACKWARD_WITH_KEYBOARD, onUserSeek), _defineProperty(_uiHandlers, _constants.UI_EVENTS.GO_FORWARD_WITH_KEYBOARD, onUserSeek), _uiHandlers);

      var videoHandlers = (_videoHandlers = {}, _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.STATE_CHANGED, this.setPlaybackStatusState), _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.ERROR, onError), _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.PLAY_ABORTED, onPlayAbort), _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.SEEK_IN_PROGRESS, onSeek), _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.MUTE_CHANGED, onMute), _defineProperty(_videoHandlers, _constants.VIDEO_EVENTS.VOLUME_CHANGED, onVolumeChange), _videoHandlers);

      (0, _entries2.default)(_extends({}, uiHandlers, videoHandlers)).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            eventName = _ref3[0],
            handler = _ref3[1];

        _this2.addListener(eventName, handler);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var children = this.props.children;


      return _react2.default.createElement(
        'section',
        null,
        _react2.default.Children.map(children, function (child) {
          return child ? _react2.default.cloneElement(child, _extends({}, _this3.state, {
            pauseVideo: _this3.pauseVideo,
            exitFullScreen: _this3.exitFullScreen,
            hidePlayerUI: _this3.hidePlayerUI,
            showPlayerUI: _this3.showPlayerUI
          })) : child;
        })
      );
    }
  }]);

  return PlayerAPIFacade;
}(_react2.default.Component), _class.dependencies = ['engine', 'eventEmitter', 'fullScreenManager', 'mainUIBlock', 'cards'], _class.propTypes = {
  eventEmitter: _propTypes2.default.object,
  engine: _propTypes2.default.object,
  fullScreenManager: _propTypes2.default.object,
  cards: _propTypes2.default.object,
  children: _propTypes2.default.node,
  mainUIBlock: _propTypes2.default.object,
  onFullScreenChanged: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onPlayAbort: _propTypes2.default.func,
  onMute: _propTypes2.default.func,
  onVolumeChange: _propTypes2.default.func,
  onSeek: _propTypes2.default.func,
  onUserSeek: _propTypes2.default.func
}, _class.defaultProps = {
  onSeek: _noop2.default,
  onUserSeek: _noop2.default,
  onError: _noop2.default,
  onPlayAbort: _noop2.default,
  onMute: _noop2.default,
  onVolumeChange: _noop2.default,
  onPlaybackStateChanged: _noop2.default
}, _temp);
exports.default = PlayerAPIFacade;
module.exports = exports['default'];